import { rankingData } from '@/mocks/home';

const trendIcons: Record<string, { icon: string; color: string }> = {
  up: { icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  down: { icon: 'ri-arrow-down-line', color: 'text-green-500' },
  new: { icon: 'ri-sparkling-line', color: 'text-accent-500' },
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热门排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">基于全网讨论热度的实时排行榜</p>

        <div className="max-w-[800px] mx-auto">
          {/* Header */}
          <div className="flex items-center px-4 py-2 text-xs font-bold text-foreground-400 uppercase tracking-wider">
            <span className="w-10">排名</span>
            <span className="flex-1">话题</span>
            <span className="w-24 text-right">热度</span>
            <span className="w-16 text-right">趋势</span>
          </div>

          {rankingData.map((item, i) => (
            <div
              key={i}
              className="flex items-center px-4 py-3 border-b border-background-200 last:border-b-0 cursor-pointer hover:bg-background-50/80 transition-colors rounded"
            >
              {/* Rank */}
              <span className={`w-10 text-lg font-bold ${
                i < 3 ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {item.rank}
              </span>

              {/* Title */}
              <span className="flex-1 text-sm font-medium text-foreground-800 truncate pr-4">
                {item.title}
              </span>

              {/* Heat */}
              <span className="w-24 text-right text-xs text-foreground-500 whitespace-nowrap">
                {item.heat}
              </span>

              {/* Trend */}
              <span className="w-16 text-right flex items-center justify-end gap-1">
                <i className={`${trendIcons[item.trend].icon} ${trendIcons[item.trend].color} text-sm`}></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}